class PermissionsService {
  private static instance: PermissionsService;

  constructor() {
    if (!PermissionsService.instance) {
      PermissionsService.instance = this;
    }

    return PermissionsService.instance;
  }

  checkPermission(permission): Promise<PermissionState> {
    return navigator?.permissions
      ?.query({ name: permission })
      .then((res: PermissionStatus) => res.state);
  }

  getPermission(permission) {
    return new Promise((resolve, reject) => {
      navigator?.permissions?.query({ name: permission }).then((res: PermissionStatus) => {
        if (res.state === 'granted') {
          resolve('done');
        } else {
          // add change event handler
          res.onchange = (event: any) => {
            if (event && event.type === 'change') {
              const newState = event?.target?.state;
              if (newState === 'granted') {
                resolve('done');
              } else {
                reject();
              }
            }
          };

          const mediaKey = permission === 'microphone' ? 'audio' : 'video';

          // trigger microphone permission prompt
          navigator?.mediaDevices?.getUserMedia({ [mediaKey]: true }).then((stream) => {
            // stop the stream so it doesn't record unnecessarily
            stream.getAudioTracks().forEach((track) => track.stop());
            resolve('done');
          });
        }
      });
    });
  }
}

export default PermissionsService;
